module.exports = __webpack_public_path__ + "static/FIBONACCI_SCENE3_SHOT4_LOOP-53215500c39e0b778697231dd7415c1a.mp4";